export default "__VITE_ASSET__5946ec5d__"